import React, { useCallback, useEffect, useMemo } from 'react';
import { Menu, MenuItem, ProSidebar, SidebarHeader, SubMenu } from 'react-pro-sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { useGetCashFlowDocumentKindsQuery } from 'bus/cash';
import { changeCollapsed } from 'bus/config/actions';

import { RootStore } from '../../../bus/configureStore';
import ClaimsProvider from '../../../components/claimsBlock';
import { useAuth } from '../../../context/auth';
import './custom.sass';
import { navigation } from './navigation';

const Aside = () => {
  const dispatch = useDispatch();
  const configStore = useSelector((store: RootStore) => store.config);
  const { data: cashFlowDocumentKinds } = useGetCashFlowDocumentKindsQuery();
  let location = useLocation();
  const { getClaims, isAdmin }: any = useAuth();

  const init = useCallback(() => {
    const drawerCollapsed = localStorage.getItem('drawerStatus');

    if (drawerCollapsed) {
      dispatch(changeCollapsed(JSON.parse(drawerCollapsed)));
    }
  }, [dispatch]);

  useEffect(() => {
    init();
  }, [init]);

  function normalizePath() {
    if (cashFlowDocumentKinds) {
      return navigation(cashFlowDocumentKinds).map((item) => {
        if (item.path && !/^\//.test(item.path)) {
          item.path = `/${item.path}`;
        }
        return { ...item };
      });
    }

    return [];
  }

  const items = useMemo(normalizePath, [cashFlowDocumentKinds]);

  const isActive = (currentPath: string = '', menuPath: string = '') => {
    return currentPath.split('/').some((i) => i === menuPath.replaceAll('/', ''));
  };

  return (
    <ProSidebar collapsed={configStore.drawerCollapsed} style={{}}>
      <SidebarHeader>
        <div
          style={{
            padding: '24px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: 14,
            letterSpacing: '1px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            //background: '#263238'
          }}
        >
          {!configStore.drawerCollapsed ? 'Панель управления' : 'ПУ'}
        </div>
      </SidebarHeader>

      <Menu iconShape="square">
        {items &&
          items.map((item, index) => {
            if (item.folder) {
              return (
                getClaims(item.claims) && (
                  <SubMenu title={item.text} icon={item.icon} key={item.text + index} placeholder={''}>
                    {item.items.map((obj, subIndex) => {
                      //console.log('location.pathname', location.pathname);
                      //console.log('obj.path', obj.path);
                      return (
                        <ClaimsProvider claimsBlock={obj.claims} key={obj.path}>
                          <MenuItem active={isActive(location.pathname, obj.path)} key={subIndex + obj.path}>
                            {obj.text}
                            <Link to={`${obj.path}`}></Link>
                          </MenuItem>
                        </ClaimsProvider>
                      );
                    })}
                  </SubMenu>
                )
              );
            } else {
              return (
                getClaims(item.claims) && (
                  <MenuItem
                    active={isActive(location.pathname, item.path || '')}
                    icon={item.icon}
                    key={item.text + index}
                  >
                    {item.text}
                    <Link to={item.path!}></Link>
                  </MenuItem>
                )
              );
            }
          })}
      </Menu>
    </ProSidebar>
  );
};

export default Aside;
